import React, { useContext } from 'react';

import {
	Container,
	Row,
	Col,
	Card,
	CardBody,
	CardTitle,
	CardSubtitle,
} from 'reactstrap';
import {
	FaEnvelope,
	FaMapMarkerAlt,
	FaPhone,
	FaArrowAltCircleLeft,
} from 'react-icons/fa';
import { ContactContext } from '../context/Context';

import { useHistory } from 'react-router-dom';

const ViewContact = () => {
	const { state } = useContext(ContactContext);
	// destructuring contact from the state
	// and rendering it in state

	const history = useHistory();

	const { contact } = state;

	return (
		<Container>
			<Row className='mt-5 mb-5'>
				<Col md='5' className='offset-md-3'>
					<Card className='pt-3 pb-5'>
						<span
							style={{
								fontSize: '2rem',
								color: '#FED54A',
								float: 'left',
								paddingLeft: '0.2em',
								cursor: 'pointer',
							}}
							onClick={() => history.push('/')}
						>
							<FaArrowAltCircleLeft />
						</span>
						<CardBody className='text-center '>
							<img
								height='150'
								width='150'
								className='cardImg profile border-danger'
								src={contact?.picture}
							/>
							<CardTitle className='text-primary mt-3'>
								<h1>{contact?.name}</h1>
							</CardTitle>
							<CardSubtitle>
								<h3>
									<FaPhone className='mr-2' />
									{contact?.phoneNumber}
								</h3>
							</CardSubtitle>
							<a
								className='btn btn-primary btn-block'
								target='_blank'
								href={`mailto:{contact?.email}`}
							>
								<FaEnvelope className='icon mr-2' />
								{contact?.email}
							</a>

							<a
								className='btn btn-primary btn-block'
								target='_blank'
								//TODO: add google maps
								href={`https://maps.google.com/?=${contact?.address}`}
							>
								<FaMapMarkerAlt className='icon mr-2' />
								{contact?.address}
							</a>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</Container>
	);
};

export default ViewContact;
